/**
 * Bundle product page behavior:
 *  - lets each item's size be changed via pill-style radio buttons,
 *    resolving the pick to a real variant id/price via that product's
 *    embedded variants JSON
 *  - keeps a live total price in sync with checked items, plus a per-item
 *    price line
 *  - keeps a live checked-item count in sync with the "SHOP THE LOOK (N)"
 *    button label, and blanks/restores each item's "1X" qty label based on
 *    whether it's checked
 *  - remembers the checked items + chosen sizes in sessionStorage so they
 *    survive navigating to a component's product page and back
 *  - adds the CHECKED components (not the bundle product itself) via the
 *    theme's Liquid Ajax Cart client, tagged so the Cart Transform Function
 *    can merge them into one checkout line
 *  - sold-out sizes get a clean SVG strike line, and unchecking an item
 *    clears its size selection's "selected" look (and vice versa: clicking
 *    an already-selected size unchecks the item) - both directions restore
 *    the last-picked size rather than resetting to a default
 *
 * The Add to Cart button is a plain <button type="button">, not a form
 * submit, so it doesn't get intercepted by the theme's existing
 * <ajax-cart-product-form> submit handler. Instead it calls
 * window.liquidAjaxCart.add() directly - the same client that handler uses
 * under the hood - so the cart drawer opens and the header cart count
 * updates exactly like a normal product add-to-cart, with no page reload.
 */
(function () {
  function formatMoney(amountCents, currencyCode) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currencyCode,
    }).format(amountCents / 100);
  }

  function buildPriceHtml(priceCents, compareCents, currencyCode) {
    var priceFormatted = formatMoney(priceCents, currencyCode);

    if (compareCents > priceCents) {
      var compareFormatted = formatMoney(compareCents, currencyCode);
      return (
        '<span class="price-highlight">' + priceFormatted + '</span>' +
        '<s class="strike-through-price">' +
        '<span class="strike-through-price__desc"> Comp. value</span>' +
        compareFormatted +
        '</s>'
      );
    }

    return '<span class="price-highlight">' + priceFormatted + '</span>';
  }

  function getCurrencyCode(root) {
    var currencyCode = root.getAttribute('data-currency-code');
    if (currencyCode) return currencyCode;

    var livePriceEl = document.querySelector('[data-bundle-live-price]');
    return (livePriceEl && livePriceEl.getAttribute('data-currency-code')) || 'USD';
  }

  // Updates the "SHOP THE LOOK (N)" button label with the current number
  // of checked items. Called from updateLivePrice so it stays in sync with
  // every place that already tracks checked-state changes (checkbox
  // toggles, size picks that flip a sold-out item off, and restoring saved
  // selection state on load).
  function updateBundleButtonCount(root) {
  var countEl = document.querySelector('[data-bundle-button-count]');
  var button = document.querySelector('[data-bundle-add-to-cart]');
  var checkedCount = root.querySelectorAll('[data-bundle-item-checkbox]:checked').length;

  if (countEl) countEl.textContent = '(' + checkedCount + ')';
  if (button) button.disabled = checkedCount === 0;
}

  function updateLivePrice(root) {
    var priceEl = document.querySelector('[data-bundle-live-price]');

    var currencyCode = getCurrencyCode(root);
    var checkboxes = root.querySelectorAll('[data-bundle-item-checkbox]:checked');

    var totalCents = 0;
    var compareTotalCents = 0;

    checkboxes.forEach(function (checkbox) {
      totalCents += parseInt(checkbox.getAttribute('data-variant-price'), 10) || 0;
      compareTotalCents += parseInt(checkbox.getAttribute('data-variant-compare-at-price'), 10) || 0;
    });

    if (priceEl) {
      priceEl.innerHTML = buildPriceHtml(totalCents, compareTotalCents, currencyCode);
    }

    updateBundleButtonCount(root);
  }

  function updateItemPrice(root, itemEl, priceCents, compareCents) {
    var priceEl = itemEl.querySelector('[data-bundle-item-price]');
    if (!priceEl) return;
    priceEl.innerHTML = buildPriceHtml(priceCents, compareCents, getCurrencyCode(root));
  }

  // Draws a clean corner-to-corner strike over a sold-out size pill via an
  // injected SVG line, rather than a CSS gradient - gradients with hard
  // color stops render jagged/pixelated at an angle on an element this
  // small. Targets whichever element actually wraps the input (its <label>,
  // or its parent if there's no label) so this works regardless of exactly
  // how the 'product-option' snippet builds the pill's markup.
  function addSoldOutStrike(radio) {
    var host = radio.closest('label') || radio.parentElement;
    if (!host || host.querySelector('[data-bundle-sold-out-strike]')) return;

    if (getComputedStyle(host).position === 'static') {
      host.style.position = 'relative';
    }
    // Clips the line to the label's own corners (rounded or not) instead of
    // letting it poke past them at the diagonal ends.
    if (getComputedStyle(host).overflow === 'visible') {
      host.style.overflow = 'hidden';
    }

    // The label (not the input) is what's actually disabled-looking here -
    // the input's own disabled state doesn't stop the label from matching
    // :hover in the theme's CSS. Killing pointer-events removes hover
    // entirely (nothing left to hover), and forces the plain default arrow
    // instead of a pointer/hand cursor.
    host.style.pointerEvents = 'none';
    host.style.cursor = 'default';

    // Matches the store's own default disabled/sold-out grey, so the size
    // letter and the strike line are the same color.
    var valueEl = host.querySelector('.product-option__value');
    if (valueEl) valueEl.style.color = '#B7B7B7';

    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('viewBox', '0 0 100 100');
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('data-bundle-sold-out-strike', '');
    svg.style.position = 'absolute';
    svg.style.inset = '0';
    svg.style.width = '100%';
    svg.style.height = '100%';
    svg.style.pointerEvents = 'none';

    var line = document.createElementNS(svgNS, 'line');
    // Inset a few percent from each corner - a thicker stroke on a line
    // that runs exactly corner-to-corner can still visually poke past a
    // rounded border even with overflow:hidden, since the stroke extends
    // outward from the line's centerline in both directions.
    line.setAttribute('x1', '5');
    line.setAttribute('y1', '95');
    line.setAttribute('x2', '95');
    line.setAttribute('y2', '5');
    line.setAttribute('stroke', '#B7B7B7');
    line.setAttribute('stroke-width', '2');
    line.setAttribute('vector-effect', 'non-scaling-stroke');

    svg.appendChild(line);
    host.appendChild(svg);
  }

  // Blanks/restores an item's "1X" qty label to track its checked state,
  // the same way syncSizeGroupWithCheckedState tracks the size pills and
  // the " / size" text - called from the same choke point so every path
  // that changes checked state (init, manual toggle, size pick flipping a
  // sold-out item off, and restoring saved state) picks this up for free.
  function updateItemQtyLabel(itemEl, isChecked) {
    var qtyEl = itemEl.querySelector('[data-bundle-item-qty]');
    if (qtyEl) qtyEl.textContent = isChecked ? '1X' : '';
    
  }

  // Keeps a size group's native radio-checked state in sync with whether
  // the item itself is checked. When unchecked, no radio is checked - so
  // whatever CSS the theme already uses to style a selected pill (via
  // :checked) simply doesn't apply to any of them, no new CSS needed. When
  // (re-)checked, restores whichever size was last picked via
  // data-current-size, which this function never modifies itself - that's
  // the "memory" that survives the item being unchecked and rechecked.
  // Also blanks/restores the " / size" text next to the title and the
  // "1X" qty label, since both should track checked state the same way the
  // pills do.
  function syncSizeGroupWithCheckedState(itemEl, isChecked) {
    updateItemQtyLabel(itemEl, isChecked);

    var group = itemEl.querySelector('[data-bundle-item-size-group]');
    if (!group) return;

    var currentSize = group.getAttribute('data-current-size');
    group.querySelectorAll('.product-option__input').forEach(function (input) {
      input.checked = isChecked && !input.disabled && input.value === currentSize;
    });

    var sizeLabel = itemEl.querySelector('[data-bundle-item-size-label]');
    if (sizeLabel) {
      sizeLabel.textContent = isChecked && currentSize ? ' / ' + currentSize.toLowerCase() : '';
    }
  }

  function initSizeGroups(root) {
    // The 'product-option' snippet doesn't set an initial checked radio or
    // disable sold-out ones on its own (that's normally done by the theme's
    // <product-radio-option> JS, which we're intentionally not using here).
    // Do both manually on load, plus the sold-out strike.
    root.querySelectorAll('[data-bundle-item]').forEach(function (itemEl) {
      var checkbox = itemEl.querySelector('[data-bundle-item-checkbox]');
      var isChecked = Boolean(checkbox && checkbox.checked);

      itemEl.querySelectorAll('[data-bundle-item-size-group] .product-option__input').forEach(function (radio) {
        if (radio.classList.contains('product-option__input--sold-out')) {
          radio.disabled = true;
          addSoldOutStrike(radio);
        }
      });

      // Sets the initial radio-checked state, the " / size" label, and the
      // "1X" qty label together, via the same shared logic every other
      // path uses.
      syncSizeGroupWithCheckedState(itemEl, isChecked);
    });
  }

  // Resolves a size pick (by option position + value) on a single item to
  // its real variant, via that item's embedded variants JSON.
  function findVariantForItem(itemEl, position, value) {
    var checkbox = itemEl.querySelector('[data-bundle-item-checkbox]');
    var variantsScript = itemEl.querySelector('[data-bundle-item-variants]');
    if (!checkbox || !variantsScript) return null;

    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (err) {
      console.error('Bundle: could not parse variants JSON', err);
      return null;
    }

    var targetOptions = [
      checkbox.getAttribute('data-option1'),
      checkbox.getAttribute('data-option2'),
      checkbox.getAttribute('data-option3'),
    ];
    targetOptions[position - 1] = value;

    return (
      variants.find(function (v) {
        return (
          (v.option1 || null) === (targetOptions[0] || null) &&
          (v.option2 || null) === (targetOptions[1] || null) &&
          (v.option3 || null) === (targetOptions[2] || null)
        );
      }) || null
    );
  }

  // Applies a resolved variant to an item's checkbox/label/price/size-group,
  // regardless of whether the pick came from a live radio click or a
  // restored sessionStorage selection.
  function applyVariantToItem(root, itemEl, match) {
    var checkbox = itemEl.querySelector('[data-bundle-item-checkbox]');
    if (!checkbox || !match) return;

    checkbox.setAttribute('data-variant-id', match.id);
    checkbox.setAttribute('data-variant-price', match.price);
    checkbox.setAttribute('data-variant-compare-at-price', match.compare_at_price || match.price);
    checkbox.setAttribute('data-option1', match.option1 || '');
    checkbox.setAttribute('data-option2', match.option2 || '');
    checkbox.setAttribute('data-option3', match.option3 || '');
    checkbox.setAttribute('data-available', match.available);

    var soldOutLabel = itemEl.querySelector('[data-bundle-item-sold-out-label]');

    if (match.available === false) {
      checkbox.checked = false;
      checkbox.disabled = true;
      if (soldOutLabel) soldOutLabel.hidden = false;
      itemEl.classList.add('product__bundle-item--unavailable');
    } else {
      checkbox.disabled = false;
      if (soldOutLabel) soldOutLabel.hidden = true;
      itemEl.classList.remove('product__bundle-item--unavailable');
      checkbox.checked = true;
    }

    var group = itemEl.querySelector('[data-bundle-item-size-group]');
    if (group) {
      var position = parseInt(group.getAttribute('data-option-position'), 10);
      var sizeValue = match['option' + position];

      if (sizeValue) {
        group.setAttribute('data-current-size', sizeValue);
      }
    }

    // Reflects checkbox.checked onto the radios (and the size label + qty
    // label) using whatever data-current-size ended up set above - covers
    // both the now-checked/now-selected case and the now-unavailable/
    // now-unchecked case in one place.
    syncSizeGroupWithCheckedState(itemEl, checkbox.checked);

    updateItemPrice(root, itemEl, match.price, match.compare_at_price || match.price);
  }

  function handleSizeChange(root, radio) {
    var group = radio.closest('[data-bundle-item-size-group]');
    var itemEl = radio.closest('[data-bundle-item]');
    if (!group || !itemEl) return;

    var position = parseInt(group.getAttribute('data-option-position'), 10);
    var match = findVariantForItem(itemEl, position, radio.value);

    if (!match) {
      console.warn('Bundle: no matching variant found for', radio.value);
      return;
    }

    applyVariantToItem(root, itemEl, match);
    updateLivePrice(root);
  }

  // Clicking the size that's already selected doesn't fire a native
  // 'change' event (its checked state didn't change), so it needs its own
  // click listener. Unchecks the item instead - the size's own checked
  // state and data-current-size are left alone, so re-checking the item
  // brings this same size right back via syncSizeGroupWithCheckedState.
  function handleSizeReClick(root, radio) {
    var group = radio.closest('[data-bundle-item-size-group]');
    var itemEl = radio.closest('[data-bundle-item]');
    if (!group || !itemEl) return;

    var wasAlreadySelected = group.getAttribute('data-current-size') === radio.value;
    var checkbox = itemEl.querySelector('[data-bundle-item-checkbox]');

    if (wasAlreadySelected && checkbox && checkbox.checked && !checkbox.disabled) {
      checkbox.checked = false;
      // Dispatch a real 'change' so the existing checkbox-change handling
      // below (live price, size-group sync, save state) all runs the same
      // way it would for a manual uncheck click.
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function getStorageKey(root) {
    var productId = root.getAttribute('data-bundle-product-id');
    return productId ? 'bundle-selection:' + productId : null;
  }

  function saveSelectionState(root) {
    var key = getStorageKey(root);
    if (!key) return;

    var state = {};
    root.querySelectorAll('[data-bundle-item]').forEach(function (itemEl) {
      var productId = itemEl.getAttribute('data-bundle-item-product-id');
      var checkbox = itemEl.querySelector('[data-bundle-item-checkbox]');
      if (!productId || !checkbox) return;

      var group = itemEl.querySelector('[data-bundle-item-size-group]');

      state[productId] = {
        checked: checkbox.checked,
        size: group ? group.getAttribute('data-current-size') : null,
      };
    });

    try {
      sessionStorage.setItem(key, JSON.stringify(state));
    } catch (err) {
      // sessionStorage may be unavailable (privacy mode, quota) - not critical.
    }
  }

  // Re-applies whatever was saved the last time this bundle was touched, so
  // clicking through to a component's product page and hitting back doesn't
  // reset the selection. Falls back to the server-rendered defaults when
  // there's nothing saved (first visit).
  function restoreSelectionState(root) {
    var key = getStorageKey(root);
    var saved = null;

    if (key) {
      try {
        var raw = sessionStorage.getItem(key);
        if (raw) saved = JSON.parse(raw);
      } catch (err) {
        saved = null;
      }
    }

    if (saved) {
      root.querySelectorAll('[data-bundle-item]').forEach(function (itemEl) {
        var productId = itemEl.getAttribute('data-bundle-item-product-id');
        var savedItem = productId ? saved[productId] : null;
        if (!savedItem) return;

        var group = itemEl.querySelector('[data-bundle-item-size-group]');
        if (group && savedItem.size && savedItem.size !== group.getAttribute('data-current-size')) {
          var position = parseInt(group.getAttribute('data-option-position'), 10);
          var match = findVariantForItem(itemEl, position, savedItem.size);
          if (match) applyVariantToItem(root, itemEl, match);
        }

        var checkbox = itemEl.querySelector('[data-bundle-item-checkbox]');
        if (checkbox && !checkbox.disabled) {
          checkbox.checked = Boolean(savedItem.checked);
        }

        // Whether or not applyVariantToItem ran above, the restored
        // checked state still needs reflecting onto the size radios and
        // the qty label.
        if (checkbox) syncSizeGroupWithCheckedState(itemEl, checkbox.checked);
      });
    }

    updateLivePrice(root);
  }

  function getBundlePayload(root) {
    var parentVariantId = root.getAttribute('data-bundle-parent-variant-id');
    var parentVariantGid = 'gid://shopify/ProductVariant/' + parentVariantId;
    var bundleTitle = root.getAttribute('data-bundle-title');
    var bundleId = 'bundle-' + parentVariantId + '-' + Date.now();

    var items = [];
    root.querySelectorAll('[data-bundle-item-checkbox]:checked').forEach(function (checkbox) {
      items.push({
        id: parseInt(checkbox.getAttribute('data-variant-id'), 10),
        quantity: 1,
        properties: {
          _bundle_id: bundleId,
          _bundle_title: bundleTitle,
          _bundle_parent_variant_id: parentVariantGid,
        },
      });
    });

    return items;
  }

  function addBundleToCart(root, button) {
    var items = getBundlePayload(root);

    if (items.length === 0) {
      root.dispatchEvent(new CustomEvent('bundle:error', { bubbles: true, detail: 'no_items_selected' }));
      return;
    }

    if (!window.liquidAjaxCart || typeof window.liquidAjaxCart.add !== 'function') {
      // Theme's ajax cart library isn't loaded; nothing safe to fall back to.
      root.dispatchEvent(new CustomEvent('bundle:error', { bubbles: true, detail: 'cart_unavailable' }));
      return;
    }

    if (button) button.disabled = true;

    // Go through the theme's own Liquid Ajax Cart client (the same one
    // <ajax-cart-product-form> uses for regular products) instead of a raw
    // fetch, so this add updates the cart icon/sections and opens the
    // drawer the same way every other add-to-cart on the site does.
    window.liquidAjaxCart.add(
      { items: items },
      {
        info: { initiator: root },
        lastCallback: function (requestState) {
          if (button) button.disabled = false;

          var ok = requestState && requestState.responseData && requestState.responseData.ok;
          if (!ok) {
            var body = requestState && requestState.responseData && requestState.responseData.body;
            root.dispatchEvent(
              new CustomEvent('bundle:error', { bubbles: true, detail: (body && body.description) || 'add_failed' })
            );
          }
        },
      }
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    var bundleRoots = document.querySelectorAll('[data-bundle-root]');

    bundleRoots.forEach(function (root) {
      initSizeGroups(root);
      restoreSelectionState(root);

      root.addEventListener('click', function (event) {
        if (event.target.matches('.product-option__input') && event.target.closest('[data-bundle-item-size-group]')) {
          handleSizeReClick(root, event.target);
        }
      });

      root.addEventListener('change', function (event) {
        if (event.target.matches('[data-bundle-item-checkbox]')) {
          var itemEl = event.target.closest('[data-bundle-item]');
          if (itemEl) syncSizeGroupWithCheckedState(itemEl, event.target.checked);
          updateLivePrice(root);
        }
        if (event.target.matches('.product-option__input') && event.target.closest('[data-bundle-item-size-group]')) {
          handleSizeChange(root, event.target);
        }
        saveSelectionState(root);
      });

      var addToCartButton = document.querySelector('[data-bundle-add-to-cart]');
      var errorsEl = document.querySelector('[data-bundle-add-to-cart-errors]');

      if (addToCartButton) {
        addToCartButton.addEventListener('click', function () {
          if (errorsEl) errorsEl.textContent = '';
          addBundleToCart(root, addToCartButton);
        });
      }

      root.addEventListener('bundle:error', function (event) {
        if (!errorsEl) return;
        var detail = event.detail;
        errorsEl.textContent =
          detail === 'no_items_selected'
            ? 'Please select at least one item.'
            : 'Something went wrong adding this to your cart. Please try again.';
      });
    });
  });
})();